import { useAuthStore } from "@/features/auth/useAuth";
import { Navigate, Outlet } from "react-router-dom";

export function RequireAdmin() {
  const { user } = useAuthStore();
  const isAdmin = user?.role === "admin" || (user != null && user.owner === null);

  if (!isAdmin) {
    return <Navigate to="/" replace />;
  }
  return <Outlet />;
}
